import { ForwardedRef, forwardRef, useEffect, useRef } from "react";

type Props = {
  scrollMarginTop?: number;
};

const RxScrollTo = forwardRef(function RxScrollTo(
  { scrollMarginTop = 100 }: Props,
  ref: ForwardedRef<HTMLImageElement>
) {
  return <div ref={ref} style={{ scrollMarginTop: scrollMarginTop }}></div>;
});

export const useScrollTo = (scroll: boolean = false) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scroll) {
      setTimeout(
        () =>
          scrollRef.current.scrollIntoView({
            inline: "center",
            behavior: "smooth",
          }),
        777
      );
    }
  }, [scroll]);

  return scrollRef;
};

export default RxScrollTo;
